import { Component, OnInit } from '@angular/core';
import {StatesService} from '../../../../utils/states.service';

@Component({
    selector: 'app-football',
    templateUrl: './football.component.html',
    styleUrls: ['./football.component.scss'],
    standalone: false
})
export class FootballComponent implements OnInit {

  constructor(public statesService: StatesService) { }

  ngOnInit(): void {
  }

}
